// Утилиты для работы с localStorage

export const storage = {
  // Получить данные из localStorage
  getItem: (key) => {
    try {
      const item = localStorage.getItem(key);
      if (item === null) return null;

      // Try to parse as JSON first, if it fails, return as string
      try {
        return JSON.parse(item);
      } catch (parseError) {
        // If JSON parsing fails, return the raw string (for tokens, etc.)
        return item;
      }
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return null;
    }
  },

  // Сохранить данные в localStorage
  setItem: (key, value) => {
    try {
      // If value is a string, store it directly, otherwise stringify
      const stringValue =
        typeof value === "string" ? value : JSON.stringify(value);
      localStorage.setItem(key, stringValue);
      return true;
    } catch (error) {
      console.error("Error writing to localStorage:", error);
      return false;
    }
  },

  // Удалить данные из localStorage
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error("Error removing from localStorage:", error);
      return false;
    }
  },

  // Очистить все данные
  clear: () => {
    try {
      localStorage.clear();
      return true;
    } catch (error) {
      console.error("Error clearing localStorage:", error);
      return false;
    }
  },
};

// Ключи для хранения данных
export const STORAGE_KEYS = {
  USER: "user",
  TOKEN: "token",
  REFRESH_TOKEN: "refresh_token",
  THEME: "theme",
  LANGUAGE: "language",
  CHAT_MESSAGES: "chatMessages", // Deprecated - используется для совместимости
  CHATS: "chats",
  SETTINGS: "settings",
  UTM_PARAMS: "utm_params",
};
